module.exports = __webpack_public_path__ + "media/B1.adec6276.mp3";